// extracted by mini-css-extract-plugin
export default {"languages":"ChooseLanguageWrapper_languages__LErsc"};